import VerifyingEmailOnPlaceChanging from './VerifyingEmailOnPlaceChanging'
import { AccessType } from 'app/auth/accessControlService'

export const VerifyingEmailOnPlaceChangingConfig = {
  settings: {
    layout: {
      config: {
        navbar: {
          display: false,
        },
        toolbar: {
          display: false,
        },
        footer: {
          display: false,
        },
        leftSidePanel: {
          display: false,
        },
        rightSidePanel: {
          display: false,
        },
      },
    },
  },
  routes: [
    {
      path: '/places/confirm-email/:token',
      component: VerifyingEmailOnPlaceChanging,
      accesses: [AccessType.ANNONYMOUS, AccessType.NOTIFICATION_VIEW_OWNED],
    },
  ],
}
